export default __webpack_public_path__ + "static/media/Flag_of_the_Valencian_Community_2x3.svg.09a91141.png";